import React from "react";
import styled from "styled-components";
import { SubsectionHeadline } from "./Typography";
import { typography, spacing } from "../styles/designSystem";

const NDASection = styled.section`
    margin-top: 4rem;
    width: 100%;

    @media (max-width: 768px) {
        margin-top: 3rem;
    }
`;

const DisclosureCard = styled.div`
    background: ${({ theme }) => theme.cardBackground};
    border: 1px solid ${({ theme }) => theme.mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.08)'};
    border-radius: 1rem;
    padding: 2rem;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;

    ul {
        margin: 0;
        padding-left: 1.5rem;
        color: ${({ theme }) => theme.subtleText};
        line-height: ${typography.lineHeight.relaxed};
        font-size: ${typography.fontSize[300]};
    }

    li {
        margin-bottom: ${spacing[300]};

        &:last-child {
            margin-bottom: 0;
        }
    }

    strong {
        color: ${({ theme }) => theme.text};
        font-weight: ${typography.fontWeight.semibold};
    }

    em {
        font-style: italic;
    }

    @media (max-width: 768px) {
        padding: 1.5rem;

        ul {
            font-size: ${typography.fontSize[200]};
        }
    }
`;

const DisclosureHeadline = styled(SubsectionHeadline)`
    margin: 0 0 ${spacing[400]};
    border-bottom: none;
    padding-bottom: 0;
`;

const NDADisclosure = () => {
    return (
        <NDASection aria-labelledby="nda-title">
            <DisclosureCard>
                <DisclosureHeadline as="h3" id="nda-title">NDA & Confidentiality Disclosure</DisclosureHeadline>
                <ul>
                    <li>
                        I've signed strict NDAs with past employers/clients. I cannot
                        publish full case studies or identifiers.
                    </li>
                    <li>
                        I'm happy to walk through detailed work <strong>live</strong>.
                    </li>
                    <li>
                        Artifacts shared privately may be <em>redacted</em> and focused on process, accessibility,
                        and outcomes.
                    </li>
                </ul>
            </DisclosureCard>
        </NDASection>
    );
};

export default NDADisclosure;
